module.exports = __webpack_public_path__ + "static/img/logo_JZ.b03be7e6.png";